module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "star-filled.fe4dfe0d.svg";